import React from "react"
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import SiteWrapper from "@components/structure/SiteWrapper/SiteWrapper"
import * as styles from "./SupplierSignupEnquiry.module.scss"

const EnquiryGallery = ({ gallery }) => {
  const sliderSettings = {
    slidesToShow: 1,
    arrows: false,
    dots: true,
    fade: true,
  }

  return (
    <section className={styles.EnquiryGallery}>
      <Slider className={styles.slider} {...sliderSettings}>
        {gallery.map((item) => (
          <div key={item.id} className={styles.slide}>
            {/* <div className={styles.wrapper}> */}
            <img src={item.icon.url} alt="" />
            <div className={styles.text}>
              <h2>{item.title}</h2>
              <p>{item.text}</p>
            </div>
            {/* </div> */}
          </div>
        ))}
      </Slider>
    </section>
  )
}

export default EnquiryGallery
